import { useTheme } from "react-jss";
import { useAppSelector } from "../../../../../redux/hooks";
import { RequestButtons } from "../buttons/requestButtons";
import { CertificatesData } from "./form/form";
import { IRequestStepProps } from "../../../../../models/requests/draft/IRequestStepProps";
import { FormDraftContainerStyle } from "../containerStyle.jss";

export const CertificatesDataContainer: React.FC<IRequestStepProps> = (props) => {
    const theme = useTheme();
    const styles = FormDraftContainerStyle({ theme });
    const { certificateStepIsValid } = useAppSelector((store) => store.draftRequest.sectionValidation);

    return (
        <>
            <div className={styles.stepperContainer}>
                <CertificatesData {...props} />
            </div>
            <RequestButtons
                isValid={certificateStepIsValid}
                isLastStep={true}
                isFirstStep={false}
                schema={props.schema}
                onCloseModal={props.onResumeAccept}
                editDraft={props.editMode ?? false}
            />
        </>
    );
};
